var compareByDepth = function compareByDepth(a, b) {
  return a.depth - b.depth;
};
export { compareByDepth };